import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import { FC } from 'react';
import { useStyles } from './style';

const ChipInProgress: FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.chipInProgress}>
      <div className={classes.textInProgress}>En cours</div>
    </div>
  );
};

export default ChipInProgress;
